'use strict';

var MarketIndicatorsBoxController = function MarketIndicatorsBoxController($scope, dataProvider) {
  $scope.componentId = 'market-indicators';
  $scope.loadData = function () {
    var filters = dataProvider.getFilters();
    if (filters === undefined || filters['filter-component'] === undefined) {
      return;
    }
    dataProvider.getData($scope.componentId).then(function (data) {
      $scope.shareValue = data.marketShare;
      $scope.ratioValue = data.demandBookedRatio;
    });
  };
  $scope.$on('brush-filter:filterApplied', $scope.loadData);
};
MarketIndicatorsBoxController.$inject = ['$scope', 'MarketIndicatorsDataProviderService'];
module.exports = MarketIndicatorsBoxController;